import { Box, PageFilters } from '@hopskipdrive/react-components';
import { colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const FilterContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  svg {
    width: 20px;
  }

  .MuiTabs-root {
    min-width: 0;
  }

  ${variables.mediaQuery.lessThan('desktop')`
    background-color: ${colorTokens.background.light};
    margin: 24px 0 0;
  `}
`;

export const TooltipBubble = styled.div`
  .MuiTooltip-popper {
    border-radius: 50%;
  }
`;

export const DateFilterContainer = styled(Box)`
  &.MuiBox-root {
    display: flex;
    align-items: center;
    grid-gap: 1rem;
    flex-direction: row;

    .MuiFormControl-root {
      width: 200px;
      ${variables.mediaQuery.lessThan('desktop')`
      width: 100%;
    `}
    }
    ${variables.mediaQuery.lessThan('desktop')`
      width: 100%;
    `}
    ${variables.mediaQuery.lessThan('tablet')`
      justify-content: center;
  `}
  }
`;

// wraps RefreshDisplay as a whole, instead of splitting DateSearchContainer's children
export const FilterPageFilters = styled(PageFilters)`
  flex-wrap: wrap;
`;

export const DateSearchContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  grid-gap: 1rem;
  row-gap: 1rem;

  ${variables.mediaQuery.lessThan('desktop')`
      width: 100%;
      align-items: center;
      grid-gap: 1rem;
    `}
  ${variables.mediaQuery.lessThan('tablet')`
       flex-direction: column;
    `}
`;
